import { List } from 'antd';
import styled, { css } from 'styled-components';
import { isMobile } from 'utils';

export const Block = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const ArtistAvatar = styled.div`
  position: absolute;
  border: 5px solid var(--v3-black-0);
  border-radius: 50%;
`;

export const CollectionName = styled.div`
  color: var(--v3-text-color);
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
  ${isMobile() &&
  css`
    font-size: 22px;
    line-height: 30px;
  `}
`;

export const ListViewHeadingWrapper = styled.div`
  justify-content: space-between;
  align-items: center;
  padding: 20px 32px;
  width: 100%;
  height: 104px;
  display: grid;
  grid-template-columns: 3fr 2fr 2fr 1fr;
  gap: 40px;
`;

export const ListViewHeading = styled.div<{ $isLast?: boolean }>`
  color: var(--v3-black-45);
  text-align: left;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  ${props =>
    props.$isLast &&
    css`
      text-align: right;
    `}
`;

export const CardContent = styled.div`
  margin-bottom: 48px;
  position: relative;
  ${ArtistAvatar} {
    position: absolute;
    left: 90px;
    transform: translate(-50%, -75%);
    ${isMobile() &&
    css`
      left: 65px;
      transform: translate(-50%, -70%);
    `}
  }
`;

export const FilterCountWrapper = styled.div`
  display: flex;
  :hover {
    cursor: pointer;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 4px;
  gap: 4px;
  height: 44px;
  background: var(--v3-black-1);
  border-radius: 12px;
  flex: none;
  flex-grow: 0;
`;

export const ListButton = styled.div<{
  $isActive?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 10px;
  height: 36px;
  border-radius: 12px;
  flex: none;
  flex-grow: 0;

  :hover {
    cursor: pointer;
  }
  ${props =>
    props.$isActive &&
    css`
      background: var(--v3-black-0);
      box-shadow: 0px 0px 6px rgba(var(--v3-black), 0.1);
    `}

  ${props =>
    !props.$isActive &&
    css`
      opacity: 0.2;
      filter: drop-shadow(0px 0px 6px rgba(var(--v3-black), 0.1));
    `}
`;

export const CollectionDescription = styled.div`
  width: 70%;
  line-height: 20px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.16px;
  ${isMobile() &&
  css`
    width: 100%;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: -0.14px;
  `}
`;

export const ListBlock = styled(List)`
  border: 1px solid var(--v3-black-2);
  margin-bottom: 20px !important;
  border-radius: 16px;
  .ant-list-item {
    display: flex;
    padding-bottom: 20px;
    justify-content: space-between;
    align-self: stretch;
    margin: 0 16px;
    padding: 15px 0 14px !important;
  }
  .ant-list-item-meta-title {
    margin-bottom: 0;
  }
  .ant-list-item-meta-title {
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    letter-spacing: -0.16px;
    color: var(--v3-black-45);
    ${isMobile() &&
    css`
      font-size: 14px;
      letter-spacing: -0.14px;
    `}
  }
`;

export const ListItemValue = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: var(--v3-text-color);
  font-style: normal;
  line-height: 20px;
  letter-spacing: -0.16px;
  ${isMobile() &&
  css`
    font-size: 14px;
    letter-spacing: -0.14px;
  `}
`;

export const ImageWrapper = styled.div`
  padding-bottom: 32.94%;
  width: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 36px;
  .ant-image {
    position: absolute;
    inset: 0;
    img {
      height: 100%;
      object-fit: cover;
    }
  }
  ${isMobile() &&
  css`
    padding-bottom: 61.94%;
    border-radius: 24px;
  `}
`;

export const CollectionInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  flex-shrink: 0;
`;

export const ListBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-self: stretch;
`;

export const Page = styled.div`
  overflow: auto;
  height: 100%;
`;

export const SkeletonWrapper = styled.div`
  background-color: var(--v3-black-1);
  .ant-skeleton {
    width: 100%;
  }

  .ant-skeleton-image {
    width: 100%;
  }
`;

export const EmptyWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 150px;

  .ant-empty-description {
    color: var(--v3-text-color);
  }
`;

export const ActivityTabWrapper = styled.div`
  width: 100%;

  .ant-empty {
    margin-top: 150px;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 24px;
  ${isMobile() &&
  css`
    display: inline-flex;
    align-items: flex-start;
    gap: 12px;
  `}
`;

export const ClearFilterWrapper = styled.div`
  display: flex;
  padding: 10px 0px 10px 24px;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
`;

export const NftCardWrapper = styled.div`
  position: relative;
  height: min-content;
  width: 100%;
`;
